export class EncodingUtils {

  //Increased performance
  public static base64DecodeUnicode(base64: string): string {
    const text: string = atob(base64);
    const length: number = text.length;
    const bytes: Uint8Array = new Uint8Array(length);
    for (let i = 0; i < length; i++) {
      bytes[i] = text.charCodeAt(i);
    }
    const decoder: TextDecoder = new TextDecoder();
    return decoder.decode(bytes);
  }

}
